const companyReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default companyReducer;